export default "__VITE_ASSET__CLS0xvqf__"